import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { NgOtpInputModule } from 'ng-otp-input';
import { provideLottieOptions } from 'ngx-lottie';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AppComponent } from './app.component';
import { InterceptorService } from './core/interceptors/interceptor.service';
import { AdminDashboardComponent } from './features/admin-portal/components/admin-dashboard/admin-dashboard.component';
import { HomeComponent } from './shared/components/home/home.component';
import { LandingPageComponent } from './shared/components/landing-page/landing-page.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { UserProfileComponent } from './shared/components/user-profile/user-profile.component';
import { AuthguardGuard } from './shared/services/authguard.guard';
import { wildcardRedirectGuard } from './shared/services/wildcard-redirect.guard';
import { SharedModule } from './shared/shared.module';

export function playerFactory() {
  return import('lottie-web');
}
// Application Routes
const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'login', redirectTo: 'shared/login', pathMatch: 'full' },
  { path: 'onboarding', component: AdminDashboardComponent },
  { path: 'landing-page', component: LandingPageComponent },
  {
    path: 'shared',
    loadChildren: () => import('./shared/shared.module').then((m) => m.SharedModule),
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthguardGuard],
        data: { permission: 'General', breadcrumb: 'Dashboard' },
      },
      {
        path: 'user-profile',
        component: UserProfileComponent,
        canActivate: [AuthguardGuard],
        data: { permission: 'General', breadcrumb: 'My Profile' },
      },
      {
        path: 'admin-portal',
        loadChildren: () =>
          import('./features/admin-portal/admin-portal.module').then((m) => m.AdminPortalModule),
      },
      {
        path: 'company-portal',
        loadChildren: () =>
          import('./features/company-portal/company-portal.module').then(
            (m) => m.CompanyPortalModule,
          ),
      },
    ],
  },
  // Dev Note: Keep this as last route.
  {
    path: '**',
    canActivate: [wildcardRedirectGuard],
    children: [],
  },
];

@NgModule({
  declarations: [AppComponent, LayoutComponent],
  bootstrap: [AppComponent],
  imports: [
    GoogleMapsModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    MatTabsModule,
    SharedModule,
    RouterModule.forRoot(routes),
    NgOtpInputModule,
    NgxPermissionsModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideLottieOptions({
      player: playerFactory, // Provide LottieOptions
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule, NgxPermissionsModule],
})
export class AppRoutingModule {}
